/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { useParsedStory } from '@micromag/core/hooks';
import { FontFaces } from '@micromag/core/components';

import ScreenListItem from './ScreenList';

const propTypes = {
    item: MicromagPropTypes.story.isRequired,
    link: PropTypes.string,
    withoutPreview: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    link: null,
    withoutPreview: false,
    className: null,
};

const StoryListItem = ({ item, link }, ...props) => {
    const { components: screens = [], fonts = null } = useParsedStory(item);
    const finalFonts = useMemo(() => fonts || [], [fonts]);

    const screensCount = screens.length;
    const screen = screensCount > 0 ? screens[0] : null;

    return (
        <ScreenListItem
            item={screen}
            link={link}
            linkParams={{
                story: item.id,
                screen: screen !== null ? screen.id : null,
            }}
            {...props}
        >
            <FontFaces fonts={finalFonts} />
            {item.title}
        </ScreenListItem>
    );
};

StoryListItem.propTypes = propTypes;
StoryListItem.defaultProps = defaultProps;

export default StoryListItem;
